import fetch from '../util/fetch'
import { backendUrl } from '../config'

export const deleteUser = ({ userName }) =>
  fetch({
    url: `${backendUrl}/delete-user?userName=${userName}`,
    method: 'POST',
  })
